// VIEWED_HOUSE

import VIEWED_HOUSE_GRAYSCALE from '../assets/images/Viewed-House-Icon-Grayscale.svg';
import VIEWED_HOUSE_COLOR_SMALL from '../assets/images/Viewed-House-Icon-Color-Small.svg';
import VIEWED_HOUSE_COLOR from '../assets/images/Viewed-House-Icon-Color.svg';
import VIEWED_HOUSE_ANIMATION from '../assets/images/Viewed-House-Icon-Animation.gif';
import VIEWED_HOUSE_ANIMATION_DOUBLE from '../assets/images/Viewed-House-Icon-Animation-2x.gif';

// SLP_VIEWED_HOUSE
import SLP_VIEWED_HOUSE_COLOR from '../assets/images/Slp-Viewed-House-Icon-Color.svg';
const SLP_VIEWED_HOUSE_GRAYSCALE = VIEWED_HOUSE_GRAYSCALE;
const SLP_VIEWED_HOUSE_COLOR_SMALL = VIEWED_HOUSE_COLOR_SMALL;
const SLP_VIEWED_HOUSE_ANIMATION = SLP_VIEWED_HOUSE_COLOR;
const SLP_VIEWED_HOUSE_ANIMATION_DOUBLE = VIEWED_HOUSE_ANIMATION_DOUBLE;

// FILLING_HOUSE

import FILLING_HOUSE_GRAYSCALE from '../assets/images/Filling-House-Icon-Grayscale.svg';
import FILLING_HOUSE_COLOR_SMALL from '../assets/images/Filling-House-Icon-Color-Small.svg';
import FILLING_HOUSE_COLOR from '../assets/images/Filling-House-Icon-Color.svg';
import FILLING_HOUSE_ANIMATION from '../assets/images/Filling-House-Icon-Animation.gif';
import FILLING_HOUSE_ANIMATION_DOUBLE from '../assets/images/Filling-House-Icon-Animation-2x.gif';

// STAR

import STAR_GRAYSCALE from '../assets/images/Star-Icon-Grayscale.svg';
import STAR_COLOR_SMALL from '../assets/images/Star-Icon-Color-Small.svg';
import STAR_COLOR from '../assets/images/Star-Icon-Color.svg';
import STAR_ANIMATION from '../assets/images/Star-Icon-Animation.gif';
import STAR_ANIMATION_DOUBLE from '../assets/images/Star-Icon-Animation-2x.gif';

// TICK_CALENDAR

import TICK_CALENDAR_GRAYSCALE from '../assets/images/Tick-Calendar-Icon-Grayscale.svg';
import TICK_CALENDAR_COLOR_SMALL from '../assets/images/Tick-Calendar-Icon-Color-Small.svg';
import TICK_CALENDAR_COLOR from '../assets/images/Tick-Calendar-Icon-Color.svg';
import TICK_CALENDAR_ANIMATION from '../assets/images/Tick-Calendar-Icon-Animation.gif';
import TICK_CALENDAR_ANIMATION_DOUBLE from '../assets/images/Tick-Calendar-Icon-Animation-2x.gif';

// ALARM_CLOCK

import ALARM_CLOCK_GRAYSCALE from '../assets/images/Alarm-Clock-Icon-Greyscale.svg';
const ALARM_CLOCK_COLOR_SMALL = ALARM_CLOCK_GRAYSCALE;
const ALARM_CLOCK_COLOR = ALARM_CLOCK_GRAYSCALE;
const ALARM_CLOCK_ANIMATION = ALARM_CLOCK_GRAYSCALE;
const ALARM_CLOCK_ANIMATION_DOUBLE = ALARM_CLOCK_GRAYSCALE;


export default {
    VIEWED_HOUSE_GRAYSCALE,
    VIEWED_HOUSE_COLOR_SMALL,
    VIEWED_HOUSE_COLOR,
    VIEWED_HOUSE_ANIMATION,
    VIEWED_HOUSE_ANIMATION_DOUBLE,
    SLP_VIEWED_HOUSE_GRAYSCALE,
    SLP_VIEWED_HOUSE_COLOR_SMALL,
    SLP_VIEWED_HOUSE_COLOR,
    SLP_VIEWED_HOUSE_ANIMATION,
    SLP_VIEWED_HOUSE_ANIMATION_DOUBLE,
    FILLING_HOUSE_GRAYSCALE,
    FILLING_HOUSE_COLOR_SMALL,
    FILLING_HOUSE_COLOR,
    FILLING_HOUSE_ANIMATION,
    FILLING_HOUSE_ANIMATION_DOUBLE,
    STAR_GRAYSCALE,
    STAR_COLOR_SMALL,
    STAR_COLOR,
    STAR_ANIMATION,
    STAR_ANIMATION_DOUBLE,
    TICK_CALENDAR_GRAYSCALE,
    TICK_CALENDAR_COLOR_SMALL,
    TICK_CALENDAR_COLOR,
    TICK_CALENDAR_ANIMATION,
    TICK_CALENDAR_ANIMATION_DOUBLE,
    ALARM_CLOCK_GRAYSCALE,
    ALARM_CLOCK_COLOR_SMALL,
    ALARM_CLOCK_COLOR,
    ALARM_CLOCK_ANIMATION,
    ALARM_CLOCK_ANIMATION_DOUBLE
};
